const FALLBACK_TEXT = 'di più';
const FALLBACK_TEXT_TOGGLED = 'di meno';
const FALLBACK_HEIGHT = 50;

export default class ExpandableCustom {
    constructor(el, togglable, control, maxHeightDesktop, maxHeightMobile, text, textToggled, toggled) {
        this.$el = $(el);
        this.$togglable = $(el).find(togglable) || $(el);
        this.$control = $(el).find(control) || $(el);
        this.maxHeightDesktop = +maxHeightDesktop || FALLBACK_HEIGHT;
        this.maxHeightMobile = +maxHeightMobile || +maxHeightDesktop || FALLBACK_HEIGHT;
        this.text = text || FALLBACK_TEXT;
        this.textToggled = textToggled || FALLBACK_TEXT_TOGGLED;
        this.toggled = Boolean(toggled);
        this.maxHeight = window.matchMedia('(max-width: 767px)').matches ? this.maxHeightMobile : this.maxHeightDesktop;
    }

    toggleOff() {
        this.$togglable.css({overflow: 'hidden', maxHeight: this.maxHeight});
        this.$control.find('.toggle__off').css({display: 'flex'});
        this.$control.find('.toggle__on').css({display: 'none'});
    }

    toggleOn() {
        this.$togglable.css({overflow: 'visible', maxHeight: 'none'});
        this.$control.find('.toggle__off').css({display: 'none'});
        this.$control.find('.toggle__on').css({display: 'flex'});
    }

    toggleExpand() {
        if (this.toggled) {
            this.toggleOff();
        } else {
            this.toggleOn();
        }
        this.toggled = !this.toggled;
    }

    addControl() {
        let control =
            `<span class="toggle__off">
                <span class="icon icon__arrow-down"></span>&nbsp;
                <span>${this.text}</span>
            </span>
            <span class="toggle__on">
                <span class="icon icon__arrow-up"></span>&nbsp;
                <span>${this.textToggled}</span>
            </span>`;

        this.$control.append(control);

        this.$control
            .off('click.expandCustom', '', $.proxy(this, 'toggleExpand'))
            .on('click.expandCustom', '', $.proxy(this, 'toggleExpand'));
    }

    init() {
        if (this.$togglable.height() > this.maxHeight) {
            this.addControl();
            this.toggleOff();
        } else {
            if (!(this.$el.is(this.$control))) {
                this.$control.remove();
            }
        }
    }
}
